/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by jessenelson on 6/15/15.
 */
'use strict';
angular.module('prism-ui.components').controller('CheckboxListController', function ($scope, uiGridConstants, $interval) {
		var self = this;

		var getIndexFor = function(propKey) {
			for (var i = 0; i < self.gridOptions.data.length; i++) {
				if (self.gridOptions.data[i].id === propKey) {
					return i;
				}
			}
		};

        self.setSelections = function() {
            $interval(function() {
                self.setRowsFromData();
            }, 0, 1);
        };

		self.gridOptions = {
			selectionRowHeaderColName: 'checkMarkRowHeaderCol',
			enableSorting: false,
			enableFiltering: false,
			enableColumnMenus: false,
			minRowsToShow: 4,
			enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
			enableVerticalScrollbar: 2,
			enableRowSelection: true,
			enableRowHeaderSelection: false,
			enableFullRowSelection: true,
			showHeader: false,
			autoResize: true,
            data: self.items,
            selectedItems: [],
			columnDefs: [
				{
					name: 'checkMarkRowHeaderCol',
					field: 'checkMark',
					width: 30,
					enableColumnMenu: false,
					enableSorting: false,
					enableColumnResizing: false,
					cellTemplate: 'components/visual/grid/check-mark-template.html',
					headerCellTemplate: 'components/visual/grid/header-check-mark-template.html'
				},
				{
					field: 'displayName',
					enableColumnMenu: false,
					enableSorting: false,
					cellTemplate: 'components/visual/grid/base-tooltip-template.html'
				}
			],
			onRegisterApi: function (gridApi) {
				self.gridApi = gridApi;
				self.gridApi.selection.on.rowSelectionChanged(null, self.selectionChanged);
			}
		};

		self.selectionChanged = function(rowChanged, event) {
            // Only reset view value if row is changed due to selection
            if (event) {
                var selectedEntities = self.gridApi.selection.getSelectedRows();
                var selectedKeys = [];
                angular.forEach(selectedEntities, function(entity) {
                    selectedKeys.push(entity.id);
                });
                self.modelCtrl.$setViewValue(selectedKeys);
            }
		};

		self.setRowsFromData = function() {
            self.gridApi.selection.clearSelectedRows();
			angular.forEach(self.modelCtrl.$modelValue, function(key) {
				var index = getIndexFor(key);
                self.gridApi.selection.selectRow(self.gridOptions.data[index]);
			});
		};
	});
